export default function doNothing(json, dispatch) {}
